import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CoreSharedModule } from '@kodit/core/shared';
import { SlanjeRobePageComponent } from './slanje-robe-page/slanje-robe-page.component';
import { EOtpremnicaRoutingModule } from './eotpremnica-routing.module';
import { EotpremnicaTableComponent } from './eotpremnica-table/eotpremnica-table.component';
import { EotpremnicaFormComponent } from './otpremnice/eotpremnica-form/eotpremnica-form.component';
import { NacinOtpremeDropdownComponent } from './ui/nacin-otpreme-dropdown/nacin-otpreme-dropdown.component';
import { TipOtpremniceDropdownComponent } from './ui/tip-otpremnice-dropdown/tip-otpremnice-dropdown.component';
import { StrankaEotpremniceAutocompleteComponent } from './ui/stranka-eotpremnice-autocomplete/stranka-eotpremnice-autocomplete.component';
import { StrankaEotpremniceComponent } from './ui/stranka-eotpremnice/stranka-eotpremnice.component';
import { FazeVoznjeComponent } from './subforms/faze-voznje/faze-voznje.component';
import { DragDropModule } from "@angular/cdk/drag-drop";
import { PredmetStavkeEotpremnicaInputComponent } from './ui/predmet-stavke-eotpremnica-input/predmet-stavke-eotpremnica-input.component';
import { StavkeEotpremniceTableComponent } from './subforms/stavke-eotpremnice-table/stavke-eotpremnice-table.component';
import { RezultatPretrageStavkeComponent } from './subforms/rezultat-pretrage-stavke/rezultat-pretrage-stavke.component';
import { TipAkcizneKategorijeDropdownComponent } from './ui/tip-akcizne-kategorije-dropdown/tip-akcizne-kategorije-dropdown.component';
import { TipPakovanjaDuvanaDropdownComponent } from './ui/tip-pakovanja-duvana-dropdown/tip-pakovanja-duvana-dropdown.component';
import { StrankaPrevoznikFazeComponent } from './ui/stranka-prevoznik-faze/stranka-prevoznik-faze.component';
import { OpasneMaterijeTableComponent } from './subforms/opasne-materije-table/opasne-materije-table.component';
import { PosaljiNaSefOtpremnicaFormComponent } from './subforms/posalji-na-sef-otpremnica-form/posalji-na-sef-otpremnica-form.component';
import { AdresaMagacinAutocompleteComponent } from './ui/adresa-magacin-autocomplete/adresa-magacin-autocomplete.component';
import { StornoEotpremnicaFormComponent } from './subforms/storno-eotpremnica-form/storno-eotpremnica-form.component';
import { StartVoznjeFormComponent } from './subforms/start-voznje-form/start-voznje-form.component';
import { PrijemRobePageComponent } from './prijem-robe-page/prijem-robe-page.component';
import { EprijemnicaTableComponent } from './eprijemnica-table/eprijemnica-table.component';
import { KreiranjePrijemniceFormComponent } from './prijemnice/kreiranje-prijemnice-form/kreiranje-prijemnice-form.component';
import { CoreSharedSubformsModule } from '@kodit/core/shared-subforms';
import { StavkeEprijemniceTableComponent } from './subforms/stavke-eprijemnice-table/stavke-eprijemnice-table.component';
import { SinhronizacijaEotpremniceFormComponent } from './subforms/sinhronizacija-eotpremnice-form/sinhronizacija-eotpremnice-form.component';
import { PdfJsViewerModule } from 'ng2-pdfjs-viewer';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CoreSharedUiModule } from '@kodit/core/shared-ui';
import { AddKomentarStavkePrijemniceComponent } from './subforms/add-komentar-stavke-prijemnice/add-komentar-stavke-prijemnice.component';
import { PromenaVozilaFormComponent } from './subforms/promena-vozila-form/promena-vozila-form.component';

@NgModule({
  imports: [
    EOtpremnicaRoutingModule,
    CoreSharedModule,
    DragDropModule,
    CoreSharedSubformsModule,
    PdfJsViewerModule
  ],
  declarations: [
    SlanjeRobePageComponent,
    EotpremnicaTableComponent,
    EotpremnicaFormComponent,
    NacinOtpremeDropdownComponent,
    TipOtpremniceDropdownComponent,
    StrankaEotpremniceAutocompleteComponent,
    StrankaEotpremniceComponent,
    FazeVoznjeComponent,
    PredmetStavkeEotpremnicaInputComponent,
    StavkeEotpremniceTableComponent,
    RezultatPretrageStavkeComponent,
    TipAkcizneKategorijeDropdownComponent,
    TipPakovanjaDuvanaDropdownComponent,
    StrankaPrevoznikFazeComponent,
    OpasneMaterijeTableComponent,
    PosaljiNaSefOtpremnicaFormComponent,
    AdresaMagacinAutocompleteComponent,
    StornoEotpremnicaFormComponent,
    StartVoznjeFormComponent,
    PrijemRobePageComponent,
    EprijemnicaTableComponent,
    KreiranjePrijemniceFormComponent,
    StavkeEprijemniceTableComponent,
    SinhronizacijaEotpremniceFormComponent,
    AddKomentarStavkePrijemniceComponent,
    PromenaVozilaFormComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CoreModuliEotpremnicaModule {}
